import Joi from 'joi';
import { formatErrorMessage } from 'validation/formatErrorMessage';

const baseEmail = Joi.string()
  .trim()
  .lowercase()
  .required()
  .email({ tlds: { allow: false } })
  .messages(formatErrorMessage('settings', 'email'));

/** Email-only (e.g. magic link, method selection). No password field. */
export const loginValidationSchema = Joi.object({
  email: baseEmail,
});

/** Email + password flow; password required. */
export const loginPasswordValidationSchema = Joi.object({
  email: baseEmail,
  password: Joi.string()
    .trim()
    .max(200)
    .required()
    .messages(formatErrorMessage('login', 'password')),
});

export default loginValidationSchema;
